import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-alert-dialog',
    templateUrl: './alert-dialog.component.html',
  })
  export class AlertDialogComponent {

  title: string;
  firstMessage: string;
  secondMessage: string;
  thirdMessage: string;
  disabled = true;
  @Input() confirmButton: string;
  @Output() eventFirstButton = new EventEmitter<any>(true);


  constructor(
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<AlertDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.title = data.title;
    this.firstMessage = data.firstMessage;
    this.secondMessage = data.secondMessage;
    this.thirdMessage = data.thirdMessage;
  }

  close(): void {
    this.dialogRef.close();
  }

  actionCheckBox(check: boolean): void {
    this.disabled = !check;
  }

  actionConfirm(): void {
    this.close();
    this.eventFirstButton.emit();
  }
}
